// 西班牙语

export default {
  t1: 'Completar',
  t5: 'Pagar',
  t6: 'Vincular y autorizar',
}
